import { render, staticRenderFns } from "./StepTasks.vue?vue&type=template&id=54671cd8&"
import script from "./StepTasks.vue?vue&type=script&lang=ts&"
export * from "./StepTasks.vue?vue&type=script&lang=ts&"
import style0 from "./StepTasks.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VCard,VForm})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\javie\\Documents\\Javier\\Developer\\Landing Dayco\\dayco-cportal-app-client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54671cd8')) {
      api.createRecord('54671cd8', component.options)
    } else {
      api.reload('54671cd8', component.options)
    }
    module.hot.accept("./StepTasks.vue?vue&type=template&id=54671cd8&", function () {
      api.rerender('54671cd8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tickets/tickets-form/access/StepTasks.vue"
export default component.exports